<template>
  <div class="l-container StudentsIndex">
    現在表示数 {{max}}

    <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'mgr'">
      <export-modal class="export-modal" :obj="obj" :columns="columns" @swi="switchV" @res="reset" @all="all" @def="def">Export</export-modal>
    </template>

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span v-for="(list, index) in columns" :key="index">
      <template v-if="sortColumn === columns[index].code">
        {{ list.name }} : {{sortState}}
      </template>
    </span>

    <h1 class="m-label m-label-custom" @click="switchColumns('columnsFlg')" v-bind:class="{ 'slideActive': columnsFlg }" v-ripple>項目</h1>
    <template v-if="columnsFlg">

      <div style="display: flex; flex-wrap: wrap">

        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="def()">DEFAULT</btn>

        <btn v-for="(list, index) in columns" :key="index" class="m-btn--column" @click.native="switchV(index)" v-bind:class="{ 'active': columns[index].show }">{{ list.name }}</btn>

      </div>
    </template>

    <btn class="resetSearch" @click.native="resetSearch">Reset</btn>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <template v-if="columns[0].show"><td-c class="sticky-1"><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c></template>
          <template v-if="columns[1].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.company_id" :options="companies" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[2].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[3].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[4].show"><td-c class="sticky-1"><input v-model="search.zip" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[5].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.pref" :options="prefs" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[6].show"><td-c class="sticky-1"><input v-model="search.address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[7].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.state" :options="state" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[8].show"><td-c class="sticky-1"><input v-model="search.name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[9].show"><td-c class="sticky-1"><input v-model="search.kana" type="text" @keyup="searchTable()" v-focus></td-c></template>
          <template v-if="columns[10].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.gender" :options="gender" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[11].show"><td-c class="sticky-1"><input v-model="search.birthday" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[12].show"><td-c class="sticky-1"><input v-model="search.age[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[13].show"><td-c class="sticky-1"><input v-model="search.age[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[14].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.school_type" :options="school_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[15].show"><td-c class="sticky-1"><input v-model="search.school_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[16].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[17].show"><td-c class="sticky-1"><input v-model="search.grade_flag" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[18].show"><td-c class="sticky-1"><input v-model="search.guidance_detail" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[19].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.priority" :options="priority" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[20].show"><td-c class="sticky-1"><input v-model="search.service_period_start" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[21].show"><td-c class="sticky-1"><input v-model="search.service_period_end" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[22].show"><td-c class="sticky-1"><input v-model="search.note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[23].show"><td-c class="sticky-1"><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="columns[0].show"><td-c class="sticky-2"><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c></template>
          <template v-if="columns[1].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_company_id" :options="companies" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[2].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[3].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[4].show"><td-c class="sticky-2"><input v-model="search.not_zip" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[5].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_pref" :options="prefs" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[6].show"><td-c class="sticky-2"><input v-model="search.not_address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[7].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_state" :options="state" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[8].show"><td-c class="sticky-2"><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[9].show"><td-c class="sticky-2"><input v-model="search.not_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[10].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_gender" :options="gender" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[11].show"><td-c class="sticky-2"><input v-model="search.not_birthday" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[12].show"><td-c class="sticky-2"><input v-model="search.not_age[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[13].show"><td-c class="sticky-2"><input v-model="search.not_age[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[14].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_school_type" :options="school_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[15].show"><td-c class="sticky-2"><input v-model="search.not_school_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[16].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[17].show"><td-c class="sticky-2"><input v-model="search.not_grade_flag" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[18].show"><td-c class="sticky-2"><input v-model="search.not_guidance_detail" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[19].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_priority" :options="priority" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[20].show"><td-c class="sticky-2"><input v-model="search.not_service_period_start" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[21].show"><td-c class="sticky-2"><input v-model="search.not_service_period_end" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[22].show"><td-c class="sticky-2"><input v-model="search.not_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[23].show"><td-c class="sticky-2"><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c v-for="(list, index) in columns" :key="index" v-if="columns[index].show" class="sticky-3" @click.native='sort(columns[index].code)'>{{ list.name }}</th-c>
        </tr-c>

        <tr-c @click.native='linkStudent($event, list)' slot="tr-td" v-for="list in mapStudents" :key="list.id" class="tr_hover">
          <template v-if="columns[0].show"><td-c>{{list.id}}</td-c></template>
          <template v-if="columns[1].show"><td-c>{{list.company}}</td-c></template>
          <template v-if="columns[2].show"><td-c>{{list.mapOffice}}</td-c></template>
          <template v-if="columns[3].show">
            <td-c v-if="list.user">{{list.user.user}}</td-c>
            <td-c v-else></td-c>
          </template>
          <template v-if="columns[4].show"><td-c>{{list.family.zip}}</td-c></template>
          <template v-if="columns[5].show"><td-c>{{list.mapPref}}</td-c></template>
          <template v-if="columns[6].show"><td-c>{{list.family.address1}} {{list.family.address2}}</td-c></template>
          <template v-if="columns[7].show"><td-c>{{list.mapState}}</td-c></template>
          <template v-if="columns[8].show"><td-c v-bind:class="[{ 'men': list.gender === 1 }, { 'women': list.gender === 2 }]">{{list.f_name}} {{list.l_name}}</td-c></template>
          <template v-if="columns[9].show"><td-c v-bind:class="[{ 'men': list.gender === 1 }, { 'women': list.gender === 2 }]">{{list.f_name_kana}} {{list.l_name_kana}}</td-c></template>
          <template v-if="columns[10].show"><td-c>{{list.mapGender}}</td-c></template>
          <template v-if="columns[11].show"><td-c>{{list.birthday}}</td-c></template>
          <template v-if="columns[12].show"><td-c>{{list.age}}</td-c></template>
          <template v-if="columns[13].show"><td-c></td-c></template>
          <template v-if="columns[14].show"><td-c>{{list.mapSchoolType}}</td-c></template>
          <template v-if="columns[15].show"><td-c>{{list.school_name}}</td-c></template>
          <template v-if="columns[16].show"><td-c>{{list.grade}}</td-c></template>
          <template v-if="columns[17].show"><td-c>{{list.grade_flag}}</td-c></template>
          <template v-if="columns[18].show"><td-c>{{list.guidance_detail}}</td-c></template>
          <template v-if="columns[19].show"><td-c>{{list.mapPriority}}</td-c></template>
          <template v-if="columns[20].show"><td-c>{{list.service_period_start}}</td-c></template>
          <template v-if="columns[21].show"><td-c>{{list.service_period_end}}</td-c></template>
          <template v-if="columns[22].show"><td-c>{{list.note}}</td-c></template>
          <template v-if="columns[23].show"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/students/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  exportUrl: url,
  pageName: 'student',
  pageNames: 'students'
}

let _ = window._
export default {
  directives: {
    focus: {
      inserted (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },
  data () {
    return {
      sortState: '降順',
      sortColumn: 'id',

      columnsFlg: false,

      columns: [
        { code: 'id', show: true, def: true, name: 'ID' },
        { code: 'company_id', show: true, def: true, name: '会社名' },
        { code: 'office_id', show: false, def: false, name: '営業所' },
        { code: 'user_id', show: false, def: false, name: '登録者' },
        { code: 'zip', show: false, def: false, name: '郵便番号' },
        { code: 'pref', show: false, def: false, name: '都道府県' },
        { code: 'address', show: false, def: false, name: '住所' },
        { code: 'state', show: true, def: true, name: '状態' },
        { code: 'name', show: true, def: true, name: '名前' },
        { code: 'kana', show: true, def: true, name: 'かな' },
        { code: 'gender', show: true, def: true, name: '性別' },
        { code: 'birthday', show: true, def: true, name: '生年月日' },
        { code: 'age_start', show: true, def: true, name: '年齢' },
        { code: 'age_end', show: true, def: true, name: '~年齢' },
        { code: 'school_type', show: true, def: true, name: '公立/私立' },
        { code: 'school_name', show: true, def: true, name: '学校名' },
        { code: 'grade', show: true, def: true, name: '学年' },
        { code: 'grade_flag', show: false, def: false, name: '留年・浪人' },
        { code: 'guidance_detail', show: true, def: true, name: '指導詳細' },
        { code: 'priority', show: true, def: true, name: '優先度' },
        { code: 'service_period_start', show: false, def: false, name: '役務開始' },
        { code: 'service_period_end', show: false, def: false, name: '役務終了' },
        { code: 'note', show: false, def: false, name: '備考' },
        { code: 'created_at', show: false, def: false, name: '作成日' }
      ],

      search: {
        id: '',
        company_id: '',
        office_id: '',
        user_id: '',
        state: '',
        zip: '',
        pref: '',
        address: '',
        name: '',
        kana: '',
        gender: '',
        birthday: '',
        age: [],
        school_type: '',
        school_name: '',
        grade: '',
        grade_flag: '',
        guidance_detail: '',
        priority: '',
        service_period_start: '',
        service_period_end: '',
        note: '',
        created_at: '',

        not_id: '',
        not_company_id: '',
        not_office_id: '',
        not_user_id: '',
        not_state: '',
        not_zip: '',
        not_pref: '',
        not_address: '',
        not_name: '',
        not_kana: '',
        not_gender: '',
        not_birthday: '',
        not_age: [],
        not_school_type: '',
        not_school_name: '',
        not_grade: '',
        not_grade_flag: '',
        not_guidance_detail: '',
        not_priority: '',
        not_note: '',
        not_created_at: ''
      },

      watch: {
        office_id: '',
        company_id: '',
        user_id: '',
        state: '',
        pref: '',
        gender: '',
        school_type: '',
        grade: '',
        guidance_detail: '',
        priority: '',

        not_company_id: '',
        not_office_id: '',
        not_user_id: '',
        not_state: '',
        not_pref: '',
        not_gender: '',
        not_school_type: '',
        not_grade: '',
        not_guidance_detail: '',
        not_priority: ''
      }
    }
  },

  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    state () {
      return this.$store.getters['students/state']
    },

    prefs () {
      return this.$store.getters.prefs.reverse()
    },

    gender () {
      return this.$store.getters['students/gender']
    },

    school_type () {
      return this.$store.getters['students/school_type']
    },

    grade () {
      return this.$store.getters['students/grade']
    },

    priority () {
      return this.$store.getters['students/priority']
    },

    students () {
      return this.$store.getters.students
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    companies () {
      return this.$store.getters.companies
    },

    offices () {
      return this.$store.getters.offices
    },

    // order By
    orderedStudents () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.students, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.students, this.sortColumn)
      }
    },

    mapStudents () {
      let self = this
      return self.orderedStudents.map((student) => {
        student.company = self.calcArry(student.family.company_id, 'companies')
        student.mapOffice = self.calcArry(student.office_id, 'offices')
        student.mapPref = self.calcArry(student.family.pref, 'prefs')
        student.mapState = self.calcSelect(student.state, 'state')
        student.mapGender = self.calcSelect(student.gender, 'gender')
        student.mapSchoolType = self.calcSelect(student.school_type, 'school_type')
        student.mapPriority = self.calcSelect(student.priority, 'priority')
        student.age = self.calcAge(student.birthday)
        student.grade = self.calcGrade(student.birthday, student.grade_flag)
        return student
      })
    }
  },
  watch: {
    'watch.company_id': function (now, old) {
      if (now) {
        this.search.company_id = now.id
      } else {
        this.search.company_id = ''
      }
    },

    'watch.not_company_id': function (now, old) {
      if (now) {
        this.search.not_company_id = now.id
      } else {
        this.search.not_company_id = ''
      }
    },

    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watch.user_id': function (now, old) {
      if (now) {
        this.search.user_id = now.id
      } else {
        this.search.user_id = ''
      }
    },

    'watch.not_user_id': function (now, old) {
      if (now) {
        this.search.not_user_id = now.id
      } else {
        this.search.not_user_id = ''
      }
    },

    'watch.pref': function (now, old) {
      if (now) {
        this.search.pref = now.id
      } else {
        this.search.pref = ''
      }
    },

    'watch.not_pref': function (now, old) {
      if (now) {
        this.search.not_pref = now.id
      } else {
        this.search.not_pref = ''
      }
    },

    'watch.state': function (now, old) {
      if (now) {
        this.search.state = now.value
      } else {
        this.search.state = ''
      }
    },

    'watch.not_state': function (now, old) {
      if (now) {
        this.search.not_state = now.value
      } else {
        this.search.not_state = ''
      }
    },

    'watch.gender': function (now, old) {
      if (now) {
        this.search.gender = now.value
      } else {
        this.search.gender = ''
      }
    },

    'watch.not_gender': function (now, old) {
      if (now) {
        this.search.not_gender = now.value
      } else {
        this.search.not_gender = ''
      }
    },

    'watch.school_type': function (now, old) {
      if (now) {
        this.search.school_type = now.value
      } else {
        this.search.school_type = ''
      }
    },

    'watch.not_school_type': function (now, old) {
      if (now) {
        this.search.not_school_type = now.value
      } else {
        this.search.not_school_type = ''
      }
    },

    'watch.grade': function (now, old) {
      if (now) {
        this.search.grade = now.value
      } else {
        this.search.grade = ''
      }
    },

    'watch.not_grade': function (now, old) {
      if (now) {
        this.search.not_grade = now.value
      } else {
        this.search.not_grade = ''
      }
    },

    'watch.priority': function (now, old) {
      if (now) {
        this.search.priority = now.value
      } else {
        this.search.priority = ''
      }
    },

    'watch.not_priority': function (now, old) {
      if (now) {
        this.search.not_priority = now.value
      } else {
        this.search.not_priority = ''
      }
    }
  },
  methods: {
    calcArry (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    calcSelect (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.value === val
        })[0].name
      } else {
        return
      }
    },

    calcAge (birthday) {
      let x = Date.parse(birthday) // 変換(ミリ秒が返される)
      let date = new Date(x) // ミリ秒をnew Dateに渡す
      let ageDifMs = Date.now() - date // 差分(ミリ秒)
      let ageDate = new Date(ageDifMs) // ミリ秒をnew Dateに渡す
      return ageDate.getUTCFullYear() - 1970
    },

    calcGrade (birthday, grade_flag) {
      let x = Date.parse(birthday) // 変換(ミリ秒が返される)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }

      let ageNumber
      for (let i = 0; i < 100; i++) {
        if (birthdate >= new Date(year - i, 3, 2) && birthdate <= new Date(year - (i - 1), 3, 1, 23, 59)) {
          ageNumber = i
        }
      }

      let gradeNumber = ageNumber + Number(grade_flag)

      let grade
      if (gradeNumber === 4) {
        grade = '幼稚園年少'
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'
      } else if (gradeNumber === 7) {
        grade = '小学1年生'
      } else if (gradeNumber === 8) {
        grade = '小学2年生'
      } else if (gradeNumber === 9) {
        grade = '小学3年生'
      } else if (gradeNumber === 10) {
        grade = '小学4年生'
      } else if (gradeNumber === 11) {
        grade = '小学5年生'
      } else if (gradeNumber === 12) {
        grade = '小学6年生'
      } else if (gradeNumber === 13) {
        grade = '中学1年生'
      } else if (gradeNumber === 14) {
        grade = '中学2年生'
      } else if (gradeNumber === 15) {
        grade = '中学3年生'
      } else if (gradeNumber === 16) {
        grade = '高校1年生'
      } else if (gradeNumber === 17) {
        grade = '高校2年生'
      } else if (gradeNumber === 18) {
        grade = '高校3年生'
      } else {
        grade = ''
      }
      return grade
    },

    linkStudent (event, student) {
      if (event.metaKey || event.ctrlKey) {
        let routeData = this.$router.resolve({name: 'studentindex', params: { id: student.id }}); window.open(routeData.href, '_blank')
      } else {
        const arr = [
          'id',
          'office_id',
          'user_id',
          'state',
          'f_name',
          'l_name',
          'f_name_kana',
          'l_name_kana',
          'gender',
          'birthday',
          'age',
          'school_type',
          'school_name',
          'guidance_detail',
          'priority',
          'old_grade',
          'grade',
          'grade_flag',
          'service_period_start',
          'service_period_end',
          'inheritance_result',
          'next_contact_date',
          'note',
          'created_at'
        ]
        arr.forEach((item) => {
          this.$store.state.item.student[item] = student[item]
        })
        this.$router.push({name: 'studentindex', params: { id: student.id }})
      }
    },

    switchColumns (col) {
      this[col] = !this[col]
    },

    switchV (col) {
      this.columns[col].show = !this.columns[col].show
    },

    reset () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = false
      }
    },

    all () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = true
      }
    },

    def () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = this.columns[i].def
      }
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.search.id = ''
      this.watch.company_id = 0
      this.watch.office_id = 0
      this.search.zip = ''
      this.watch.pref = 0
      this.search.address = ''
      this.watch.state = 0
      this.search.name = ''
      this.search.kana = ''
      this.watch.gender = 0
      this.search.birthday = ''
      this.search.age = []
      this.watch.school_type = 0
      this.search.school_name = ''
      this.watch.grade = 0
      this.search.grade_flag = ''
      this.search.guidance_detail = ''
      this.watch.priority = 0
      this.search.service_period_start = ''
      this.search.service_period_end = ''
      this.search.note = ''

      this.search.not_id = ''
      this.watch.not_company_id = 0
      this.watch.not_office_id = 0
      this.search.not_zip = ''
      this.watch.not_pref = 0
      this.search.not_address = ''
      this.watch.not_state = 0
      this.search.not_name = ''
      this.search.not_kana = ''
      this.watch.not_gender = 0
      this.search.not_birthday = ''
      this.search.not_age = []
      this.watch.not_school_type = 0
      this.search.not_school_name = ''
      this.watch.not_grade = 0
      this.search.not_grade_flag = ''
      this.search.not_guidance_detail = ''
      this.watch.not_priority = 0
      this.search.not_service_period_start = ''
      this.search.not_service_period_end = ''
      this.search.not_note = ''

      this.searchTable()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('StudentsSearch')
      let obj = JSON.parse(getjson)

      vm.search.id = obj['id']
      vm.watch.company_id = obj['company_id']
      vm.watch.office_id = obj['office_id']
      vm.search.zip = obj['zip']
      vm.watch.pref = obj['pref']
      vm.search.address = obj['address']
      vm.watch.state = obj['state']
      vm.search.name = obj['name']
      vm.search.kana = obj['kana']
      vm.watch.gender = obj['gender']
      vm.search.birthday = obj['birthday']
      vm.search.age = obj['age']
      vm.watch.school_type = obj['school_type']
      vm.search.school_name = obj['school_name']
      vm.watch.grade = obj['grade']
      vm.search.grade_flag = obj['grade_flag']
      vm.search.guidance_detail = obj['guidance_detail']
      vm.watch.priority = obj['priority']
      vm.search.service_period_start = obj['service_period_start']
      vm.search.service_period_end = obj['service_period_end']
      vm.search.note = obj['note']
      vm.search.created_at = obj['created_at']

      vm.search.not_id = obj['not_id']
      vm.watch.not_company_id = obj['not_company_id']
      vm.watch.not_office_id = obj['not_office_id']
      vm.search.not_zip = obj['not_zip']
      vm.watch.not_pref = obj['not_pref']
      vm.search.not_address = obj['not_address']
      vm.watch.not_state = obj['not_state']
      vm.search.not_name = obj['not_name']
      vm.search.not_kana = obj['not_kana']
      vm.watch.not_gender = obj['not_gender']
      vm.search.not_birthday = obj['not_birthday']
      vm.search.not_age = obj['not_age']
      vm.watch.not_school_type = obj['not_school_type']
      vm.search.not_school_name = obj['not_school_name']
      vm.watch.not_grade = obj['not_grade']
      vm.search.not_grade_flag = obj['not_grade_flag']
      vm.search.not_guidance_detail = obj['not_guidance_detail']
      vm.watch.not_priority = obj['not_priority']
      vm.search.not_service_period_start = obj['not_service_period_start']
      vm.search.not_service_period_end = obj['not_service_period_end']
      vm.search.not_note = obj['not_note']
      vm.search.not_created_at = obj['not_created_at']

      for (let i = 0; i < vm.columns.length; i++) {
        const column = 'column_' + vm.columns[i].code
        vm.columns[i].show = obj[column]
      }

      vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {

      id: this.search.id,
      company_id: this.watch.company_id,
      office_id: this.watch.office_id,
      zip: this.search.zip,
      pref: this.watch.pref,
      address: this.search.address,
      state: this.watch.state,
      name: this.search.name,
      kana: this.search.kana,
      gender: this.watch.gender,
      birthday: this.search.birthday,
      age: this.search.age,
      school_type: this.watch.school_type,
      school_name: this.search.school_name,
      grade: this.watch.grade,
      grade_flag: this.search.grade_flag,
      guidance_detail: this.search.guidance_detail,
      priority: this.watch.priority,
      service_period_start: this.search.service_period_start,
      service_period_end: this.search.service_period_end,
      note: this.search.note,
      created_at: this.search.created_at,

      not_id: this.search.not_id,
      not_company_id: this.watch.not_company_id,
      not_office_id: this.watch.not_office_id,
      not_zip: this.search.not_zip,
      not_pref: this.watch.not_pref,
      not_address: this.search.not_address,
      not_state: this.watch.not_state,
      not_name: this.search.not_name,
      not_kana: this.search.not_kana,
      not_gender: this.watch.not_gender,
      not_birthday: this.search.not_birthday,
      not_age: this.search.not_age,
      not_school_type: this.watch.not_school_type,
      not_school_name: this.search.not_school_name,
      not_grade: this.watch.not_grade,
      not_grade_flag: this.search.not_grade_flag,
      not_guidance_detail: this.search.not_guidance_detail,
      not_priority: this.watch.not_priority,
      not_service_period_start: this.search.not_service_period_start,
      not_service_period_end: this.search.not_service_period_end,
      not_note: this.search.not_note,
      not_created_at: this.search.not_created_at
    }

    for (let i = 0; i < this.columns.length; i++) {
      const column = 'column_' + this.columns[i].code
      obj[column] = this.columns[i].show
    }

    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('StudentsSearch', setjson)
    next()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.sticky-1 {
  position: sticky;
  z-index: 4;
  top: 0;
  background: #fff;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    top: -1px;
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}
.sticky-2 {
  position: sticky;
  z-index: 3;
  top: 26px;
  background: #fff;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}
.sticky-3 {
  position: sticky;
  z-index: 2;
  top: 52px;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}

.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(100vh - 210px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f2bd";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}

.export-modal {
  position: absolute;
  top: 48px;
  right: 9px;
}

.men {
  color: #3F51B5;
}
.women {
  color: #E91E63;
}
</style>

<style lang="scss">
.StudentsIndex {
  .multiselect {
    min-height: 23px;
    min-width: 110px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 65%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// StudentsIndex.vue?f963abde